export const VERSION = 'dev-master#a68e463';
